import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle, IconButton } from '@mui/material';
import { StockCountZonesContext, StockCountZonesContextValues } from '../../contexts/StockCountZonesContext';
import { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const StockCountZonesDeleteItemsModal = () => {
  const { t,
    isItemsDeleteModalOpen,
    handleClose,
    deleteItems } = useContext(StockCountZonesContext) as StockCountZonesContextValues;

  return (
    <Dialog open={isItemsDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('items.deleteTitle')}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
            color: (theme) => theme.palette.custom.gray[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>{t('items.deleteConfirm')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}>
          {t('modals.cancel')}
        </Button>
        <Button variant="bad"
          size='lg'
          onClick={deleteItems}>
          {t('modals.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountZonesDeleteItemsModal;